export default "__VITE_ASSET__CzcvuNaC__"